import { createStyles, makeStyles } from '@material-ui/core';
import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      listStyleType: 'none',
      display: 'flex',
      marginBottom: SMALL_MARGIN,
      position: 'relative',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    iconWrapper: {
      marginRight: MIDDLE_MARGIN,
    },
    testIcon: {
      width: 28,
      height: 28,
    },
    title: {
      fontSize: 18,
      lineHeight: 1.5,
      color: colorsPalette.gray,
    },
    circle: {
      width: 30,
      height: 30,
      minWidth: 30,
      borderRadius: '50%',
      background: colorsPalette.green,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    circleIcon: {
      width: 14,
      height: 14,
    },
  }),
);

export default useStyles;
